import { Button, Col, Modal, Row } from "antd";
import PageTerm from "component/page/page_term";
import { useActionTermAndPolicy } from "hook/term/useActionTerm";
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DialogTermOfService = () => {
  // -------------------------- VAR -----------------------------
  const { term } = useActionTermAndPolicy();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Modal
      open={term.open}
      onCancel={term.handleClose}
      title="ĐIỀU KHOẢN SỬ DỤNG DỊCH VỤ"
      footer={null}
    >
      <Row gutter={[0, 16]}>
        <Col xl={24} lg={24} md={24} xs={24}>
          <div className="h-[550px] overflow-auto border-[1px] border-gray-300">
            <PageTerm />
          </div>
        </Col>
        <Col align="right" xl={24} lg={24} md={24} xs={24}>
          <Button onClick={() => term.handleClose()} type="primary">
            Đã xem
          </Button>
        </Col>
      </Row>
    </Modal>
  );
};
export default DialogTermOfService;
